import Image from 'next/image';
import { useRouter } from 'next/router';
import ReactMarkdown from 'react-markdown';
import { IBlogPost } from '../../models/strapi.models';
import { formatDate, getImageSrcWithFallback } from '../../shared/useUtils';
import { IAppPage } from '../../store/slices/appSlice';
import { BlogItemListStyle } from '../../styles/components/blog';

export interface IBlogItemFeaturedProps extends IBlogPost {
  appPages: IAppPage[];
}

const BlogItemFeatured = (props: IBlogItemFeaturedProps) => {
  const router = useRouter();

  // Construct URL directly from slug (already comes with correct path from Strapi)
  const postUrl = props.slug
    ? `${router.locale !== 'en' ? `/${router.locale}` : ''}/${props.slug}`
    : '#';

  return (
    <a href={postUrl}>
      <div className={BlogItemListStyle.blogItemFeatured}>
        <div className={BlogItemListStyle['content']}>
          <div className={BlogItemListStyle['thumbnailWrap']}>
            <div className={BlogItemListStyle['thumbnail']}>
              <Image
                quality={90}
                alt={props.image?.alternativeText || props.title}
                fill
                sizes="(max-width: 768px) 100vw, 1200px"
                priority={true}
                src={
                  getImageSrcWithFallback(props.image, 'medium') ||
                  '/assets/images/blog/blog-placeholder-image.png'
                }
              />
            </div>
          </div>
          <div className={BlogItemListStyle['details']}>
            <h1>{props.title}</h1>
            <ReactMarkdown
              allowedElements={['strong', 'em', 'code', 'a', 'br', 'span']}
              unwrapDisallowed={true}>
              {props.metaDescription}
            </ReactMarkdown>
            <div className={BlogItemListStyle['metadata']}>
              <p>
                <span>{props.author?.fullname}</span>
                {props.publicationDate && (
                  <span>{formatDate(props.publicationDate)}</span>
                )}
              </p>
            </div>
          </div>
        </div>
        <div></div>
      </div>
    </a>
  );
};

export default BlogItemFeatured;
